import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {ApiService} from "../../../../services/api.service";
import {NzModalRef, NzModalService} from "ng-zorro-antd/modal";

@Component({
  selector: 'app-update-user-role',
  templateUrl: './update-user-role.component.html',
  styleUrls: ['./update-user-role.component.scss']
})
export class UpdateUserRoleComponent implements OnInit {

  @Input() user: any;
  roleForm: FormGroup
  submitting: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private api: ApiService,
    private modalCtrl: NzModalRef,
    private fb: FormBuilder
  ) {
    this.roleForm = this.fb.group({
      role: [null, Validators.required]
    });
  }

  ngOnInit() {
    console.log(this.user.role);
    this.roleForm.get('role')?.setValue(this.user.role);
  }

  submitRoleForm(): void{
    this.api.apiPost('core/admin/users/' + this.user.id + '/role', this.roleForm.value, false, true).then((UpdateRoleResult)=>{
      this.modalCtrl.destroy(UpdateRoleResult);
    }).catch(async (UpdateRoleError)=> {


    });
  }

  destroyModal(): void {
    this.modalCtrl.destroy();
  }

  protected readonly focus = focus;
}
